import styled from 'styled-components';
import { FaMotorcycle } from 'react-icons/fa';

interface ContainerProps {
  width?: string;
  margin?: string;
  alignContent?: string;
  heigth?: string;
}

interface IconProps {
  fontSize?: string;
}

export const IconMotoboy = styled(FaMotorcycle)<IconProps>`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme, fontSize }) => fontSize ?? theme.fontSizes.ultraLarge};
  margin-right: 8px;
`;

export const Container = styled.div<ContainerProps>`
  width: ${({ width }) => width ?? '400px'};
  margin: ${({ margin }) => margin ?? '15px 0px 0px'};
  height: ${({ heigth }) => heigth ?? 'auto'};
  align-content: ${({ alignContent }) => alignContent ?? 'center'};
`;
